<div class="container-fluid config-layout-shell px-0">
  <div
    v-if="show_mobile_drawer && !should_hide_sidebar"
    class="mobile-backdrop"
    @click="close_mobile_sidebar"
  ></div>

  <div v-if="show_mobile_drawer && !should_hide_sidebar" class="mobile-drawer">
    <button
      class="mobile-drawer-close btn p-0 border-0 bg-transparent"
      @click="close_mobile_sidebar"
      aria-label="Close menu"
    >
      <i class="bi bi-x-lg fs-5"></i>
    </button>
    <ConfigSidebar @close="close_mobile_sidebar" />
  </div>

  <div class="row g-0 h-100 position-relative">
    <div
      v-if="!should_hide_sidebar"
      :class="[
        'sidebar-shell d-none d-lg-flex',
        is_sidebar_hidden ? 'sidebar-shell-collapsed' : 'sidebar-shell-expanded'
      ]"
    >
      <div class="sidebar-col">
        <div class="flex-grow-1 h-100">
          <ConfigSidebar @close="is_sidebar_hidden = true" />
        </div>
      </div>

      <button
        type="button"
        class="sidebar-toggle-arrow d-none d-lg-flex align-items-center justify-content-center position-absolute btn-primary-dark rounded-circle shadow border-0"
        :class="is_sidebar_hidden ? 'arrow-collapsed' : 'arrow-expanded'"
        @click="is_sidebar_hidden = !is_sidebar_hidden"
      >
        <i
          class="bi text-white fs-6"
          :class="is_sidebar_hidden ? 'bi-chevron-right' : 'bi-chevron-left'"
        ></i>
      </button>
    </div>

    <div
      class="main-content-wrapper transition-all d-flex flex-column h-100"
    >

      <div class="main-content border-card rounded-0 overflow-auto scroll-container">
        <router-view class="mt-1"></router-view>
      </div>
    </div>
  </div>
</div>
